import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyServiceCenter = loadable(() => import(/* webpackChunkName: "content/servicecenter" */ '.'));
